<template>
    <div id="oksana" class="section">
        <span v-if="language==='EN'">
            <PageTitle :title="'Oksana'" :subtitle="subtitle_EN" :description="description_EN" />
            <Resume_EN />
        </span>
        <span v-if="language==='RU'">
            <PageTitle :title="'Оксана'" :subtitle="subtitle_RU" :description="description_RU" />
            <Resume_RU />
        </span>
        <span v-if="language==='UA'">
            <PageTitle :title="'Оксана'" :subtitle="subtitle_UA" :description="description_UA" />
            <Resume_UA />
        </span>     
    </div>
</template>

<script>
    import PageTitle from '@/components/PageTitle'
    import { MyFunctions } from '@/data/functions.js'
    import Resume_EN from '@/components/resumes/resume_en'
    import Resume_RU from '@/components/resumes/resume_ru'
    import Resume_UA from '@/components/resumes/resume_ua'

    export default {
    name: 'Oksana',
       components: { PageTitle, Resume_EN, Resume_RU, Resume_UA },
       data: () => ({
           language: '',

           subtitle_EN: 'DRAMA & MOVIE THEATRE ACTRESS',
           subtitle_RU: 'АКТРИСА ДРАМАТИЧЕСКОГО ТЕАТРА И КИНО',           
           subtitle_UA: 'АКТРИСА ДРАМАТИЧНОГО ТЕАТРУ І КІНО',

           description_EN: '"…Being an actress and singer is more than just a profession. It is a destiny, a way of life. It involves constant self-improvement, a perpetual honing of skills. But the greatest miracle and satisfaction, is to live the lives of others, their destinies on stage, to communicate the deepest meanings, subtexts, which the author or composer had in mind … and if one is really lucky, achieve true happiness!" Oksana Kowcz',  
           description_RU: 'Быть актёром ... не профессия - судьба, жизненный уклад - кропотливая, ежедневная работа над собой. Но величайшее чудо и счастье иметь возможность переживать на сцене другие судьбы ... доносить до зрителя глубокую суть – подтекст того, что на самом деле хотел выразить автор ... и если удается - это настоящее счастье! Оксана Ковч',
           description_UA: 'Бути актором ... не професія - доля, спосіб життя - шалена щоденна праця над собою. Але найбільше диво і щастя мати змогу проживати на сцені інші долі ... доносити до глядача глибоку суть – підтекст, саме те, що насправді хотів сказати автор ... і якщо вдається - справжнє щастя! Оксана Ковч'                      
       }),
       mounted(){
            this.language = MyFunctions.getLanguage()
       } 
    }
</script>


<style>
    #oksana {
        margin-top: -22px!important;
    }
    #resume h3 {
        color: #339900;
        font-size: 16px!important;
        text-transform: uppercase; 
    }
    #resume p, ul li {
        font-family: Arial;
        color: #222;
        text-align: left;
    }  
    #resume .title {
        color: #333;
    }  
    h2.studio {
        font-size: 30px;
        padding: 10px 0;
    }
</style>
